export enum MeasurementType {
    Temperature = 'Temperature',
    Humidity = 'Humidity',
    LightIntensity = 'LightIntensity',
    CO2 = 'CO2',
    Movement = 'Movement',
    NoiseLevel = 'NoiseLevel',
}
